import React from 'react'
import { AutoColumn } from '../../../../../components/Column'
import NFTMarketPlaceMenu from '../../../components/NFTMarketPlaceMenu'
import { ReactComponent as Multiple } from '../../../../../assets/images/multiple.svg'
import { ReactComponent as Single } from '../../../../../assets/images/single.svg'
import NFTGoBack from '../../../components/NFTGoBack'
import {
  PageWrapper,
  Title,
  BottomDescription,
  TopDescription,
  ContentItem,
  ContentItemLink,
  Content,
  CreateWrapper
} from './NFTCreateStyled'
import styled from 'styled-components'
import { ChainId } from '@yetiswap/sdk'
import { useWeb3React } from '@web3-react/core'

const ConnectWarning = styled.div`
  margin-top: 2rem;
  display: flex;
  justify-content: center;
  width: 100%;
  font-size: 3rem;
  font-weight: bold;
`

export default function NFTCreate() {
  const { chainId } = useWeb3React()
  return (
    <PageWrapper>
      <AutoColumn style={{ width: '100%', maxWidth: '1024' }}>
        <NFTMarketPlaceMenu />
        {chainId !== ChainId.FUJI ? (
          <ConnectWarning>
            PLEASE CONNECT TO <br /> AVALANCHE FUJI C-CHAIN
          </ConnectWarning>
        ) : (
          <CreateWrapper>
            <NFTGoBack text="Go Back" url={'/nft-marketplace'} />
            <Title>Create collectible</Title>
            <TopDescription>
              Choose “Single” if you want your collectible to be one of a kind or “Multiple” if you want to sell one
              collectible multiple times
            </TopDescription>
            <Content>
              <ContentItemLink to={'/nft-create/erc721'}>
                <Single />
                Single
              </ContentItemLink>
              <ContentItem title="Coming Soon">
                <Multiple />
                <div className="text">Multiple</div>
                <div className="coming-soon">Coming Soon</div>
              </ContentItem>
            </Content>
            <BottomDescription>
              We do not own your private keys and cannot access your funds without your confirmation
            </BottomDescription>
          </CreateWrapper>
        )}
      </AutoColumn>
    </PageWrapper>
  )
}
